export const checkIfAllCookiesAllowed = () => {
  if (localStorage.getItem('@buffl:clients-pp-v2-accepted') === '1') {
    return true;
  }
  return false;
};

export default checkIfAllCookiesAllowed;
